import React from 'react';
import { Query } from 'react-apollo';
import getOr from '~/util/getOr';

import GolfEventInfo from '~/graphql/queries/GolfEventInfo.graphql';
import GraphQLEventDescriptionCard from '~/components/GraphQLEventDescriptionCard/GraphQLEventDescriptionCard';
import GolfCard from '~/components/GraphQLEventDescriptionCard/LeagueCards/GolfCard';

class GraphQLEventDescriptionContainer extends React.Component {
  static displayName = 'GraphQLEventDescriptionContainer';

  render() {
    let query;
    let variables = {};
    let Details;

    if (this.props.league === 'pga' || this.props.league === 'lpga') {
      variables = { golfEventId: getOr(this.props, 'event.id', null) };
      query = GolfEventInfo;
      Details = GolfCard;
    }

    return (
      <Query query={query} variables={variables}>
        {({ data, loading, error }) => {
          if (loading || error) return null;

          return (
            <GraphQLEventDescriptionCard data={data} Details={Details} event={this.props.event} />
          );
        }}
      </Query>
    );
  }
}

export default GraphQLEventDescriptionContainer;
